import { useApiTradeV1SiteMaterialsRetrieve } from 'api';
import { useParams } from 'react-router-dom';

export const useGetSiteMaterialDetails = () => {
  const { siteMaterialId } = useParams();

  if (!siteMaterialId) {
    throw new Error('Site Material Id is required');
  }

  const { data: siteMaterialData, isLoading } = useApiTradeV1SiteMaterialsRetrieve(siteMaterialId);

  return {
    data: siteMaterialData,
    id: Number(siteMaterialId),
    isLoading: isLoading,
  };
};
